import { useState } from "react";
import { Building2, ChevronDown } from "lucide-react";
import { PropertyGroupMenu } from "@/components/form/PropertyGroupMenu";

const newId = () => ((typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `u${Date.now()}${Math.random()}`);

const norm = (s) => (s || "").toLowerCase().replace(/[^a-z0-9 ]/g, "").trim();
// Same rule as the Rates table: "Belise" counts as Belise Apartments
const matches = (title, name) => { const t = norm(title), n = norm(name); return !!t && (t === n || n.startsWith(`${t} `) || t.startsWith(n)); };

// Bulk-add one sub-task per property (all, by region, or one at a time); each row is tied to its property.
export function PropertySubtaskTools({ properties, list, onChange }) {
  const [open, setOpen] = useState(false);
  const have = new Set(properties.filter((p) => list.some((s) => s.property_id === p.id || (!s.property_id && matches(s.title, p.name)))).map((p) => p.id));
  const missing = properties.filter((p) => !have.has(p.id));
  const add = (ids) => {
    const rows = properties.filter((p) => ids.includes(p.id) && !have.has(p.id))
      .map((p) => ({ id: newId(), title: p.name, property_id: p.id, assigned_to_id: null, completed: false }));
    if (rows.length) onChange([...list, ...rows]);
  };
  return (
    <div className="space-y-2" data-testid="subtask-property-tools">
      <button type="button" onClick={() => setOpen((o) => !o)} className="flex items-center gap-1.5 text-xs font-semibold text-sky-700 hover:underline" data-testid="subtask-property-toggle">
        <Building2 className="h-3.5 w-3.5" /> Property checklist <ChevronDown className={`h-3 w-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="flex flex-wrap items-center gap-2 rounded-lg bg-slate-50 p-2">
          <button type="button" onClick={() => add(missing.map((p) => p.id))} disabled={!missing.length}
            className="rounded-md border border-sky-200 bg-white px-2.5 py-1 text-xs font-semibold text-sky-700 hover:bg-sky-50 disabled:opacity-40" data-testid="subtask-add-all-properties">
            + Add all properties{missing.length ? ` (${missing.length})` : ""}
          </button>
          <PropertyGroupMenu value={[...have]} validIds={new Set(properties.map((p) => p.id))} onAdd={add} testid="subtask-property-group" />
          <select value="" onChange={(e) => e.target.value && add([e.target.value])} disabled={!missing.length}
            className="h-7 rounded-md border border-slate-200 bg-white px-2 text-xs focus:border-sky-400 focus:outline-none" data-testid="subtask-add-property">
            <option value="">+ Add one property…</option>
            {missing.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
          <span className="text-[11px] text-slate-400">Remove any that don't apply with ×.</span>
        </div>
      )}
    </div>
  );
}
